// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__36h3A"};